import type { RiseDay } from "./types/ui-types";

/**
 * The eight-day countdown, one game per weekday from Wed Oct 14 to Fri Oct 23, rotating Connections,
 * Mini Crossword and Wordle. Safe to ship to the browser: answers live in `puzzles.server.ts`.
 */
export const RISE_DAYS: readonly RiseDay[] = [
  { day: 1, date: "2026-10-14", daysToNola: 12, game: "connections", title: "Connections" },
  { day: 2, date: "2026-10-15", daysToNola: 11, game: "crossword", title: "Eat your way through NOLA" },
  { day: 3, date: "2026-10-16", daysToNola: 10, game: "wordle", title: "Wordle" },
  { day: 4, date: "2026-10-19", daysToNola: 7, game: "crossword", title: "Second line" },
  { day: 5, date: "2026-10-20", daysToNola: 6, game: "wordle", title: "Wordle" },
  { day: 6, date: "2026-10-21", daysToNola: 5, game: "connections", title: "Connections" },
  { day: 7, date: "2026-10-22", daysToNola: 4, game: "crossword", title: "EA survival kit" },
  { day: 8, date: "2026-10-23", daysToNola: 3, game: "wordle", title: "Wordle" },
];

/** Player-facing name for each game type. */
export const RISE_GAME_LABELS: Record<RiseDay["game"], string> = {
  wordle: "Wordle",
  connections: "Connections",
  crossword: "Mini crossword",
};

/**
 * Look up a countdown day.
 *
 * @param day - Campaign day number, 1-based.
 * @returns The day, or undefined when the number is outside the countdown.
 */
export function getRiseDay(day: number): RiseDay | undefined {
  return RISE_DAYS.find((d) => d.day === day);
}
